<template>
  <VDialog max-width="800" v-model="dialog">
    <VCard>
      <VBtn absolute style="right: 0" icon @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardText v-if="order">
        <div class="d-flex pt-8 pb-3 justify-space-between align-center">
          <VCardTitle class="pa-0"
            >{{ $t("orderHistoryNumb", { numb: order.numb }) }}
          </VCardTitle>
          <!--          <VBtn-->
          <!--            color="primary"-->
          <!--            :to="{ name: 'order-history', query: { numb: order.numb } }"-->
          <!--          >-->
          <!--            {{ $t("viewHistory") }}-->
          <!--          </VBtn>-->
        </div>
        <TableWithChildren
          :items="histories"
          :headers="headers"
          :loading="loading"
        >
          <template #item.state="{ item }">{{ $t(item.state) }}</template>
          <template #item.action="{ item }">
            <VBtn
              :to="{
                name: 'order-history-item',
                query: {
                  itemNumb: item.itemNumb,
                  numb: order.numb,
                  orderId: orderId,
                },
              }"
              class="new_style"
            >
              <VueIcon icon="newTimeIcon" />
            </VBtn>
          </template>
        </TableWithChildren>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
import TableWithChildren from "@/components/table-with-children/tableWithChildren";
import { data } from "browserslist";

export default {
  name: "OrderHistoryDialog",
  components: { TableWithChildren },
  data() {
    return {
      dialog: false,
      orderId: null,
      histories: [],
      order: {
        numb: null,
      },
      loading: false,
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.histories = [];
        this.order = {
          numb: null,
        };
      }
    },
  },
  methods: {
    async open(id) {
      this.dialog = true;
      this.loading = true;
      try {
        const { data } = await this.$http.get("office/orders/node", {
          params: { id },
        });
        // this.order = {
        //   numb,
        // };
        this.orderId = data.data.id;
        this.histories = data.data.items;
        this.order.numb = data.data.numb;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
    },
  },
  computed: {
    data() {
      return data;
    },
    headers() {
      return [
        {
          text: this.$t("orderRequestItemNumber"),
          value: "itemNumb",
        },
        {
          text: this.$t("productName"),
          value: "productName",
        },
        {
          text: this.$t("count"),
          value: "count",
        },
        {
          text: this.$t("measureShort"),
          value: "unitType",
        },
        {
          text: this.$t("state"),
          value: "state",
        },
        {
          text: this.$t("action"),
          value: "action",
        },
      ];
    },
  },
};
</script>
